export function trueNologin(data) {
const nologin = ["login","indexPage","jxgg","xwzx",'msfc','jxggIndex','xwzxIndex','msfcIndex','lxwm',]
    let num = nologin.indexOf(data);
    if (num === -1) {
        return false
    } else {
        return true
    }
}

export function trueEnrolled(data) {
    const nologin = ["wdkc","sxpt","xjgl","xydt",'khjy','xgxx','courseAssess']
        let num = nologin.indexOf(data);
        if (num === -1) {
            return false
        } else {
            return true
        }
}

export function trueCertificate(data) {
    const nologin = ["bmdj",'xjgl']
        let num = nologin.indexOf(data);
        if (num === -1) {
            return false
        } else {
            return true
        }
}


// WEBPACK FOOTER //
// ./src/pages/index/router/utils.js